export default __webpack_public_path__ + "static/media/Click.b17f4906.svg";